// src/pages/CategoryPage.js
import React, { useContext, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AppContext } from "../App";
import { documentCategories } from "../data/documentCategories";
import GlassCard from "../components/GlassCard";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import CategoryDescription from "../components/CategoryDescription";
import CategoryInlineAd from "../components/ads/CategoryInlineAd";

const CategoryPage = () => {
  const { id } = useParams();
  const { language } = useContext(AppContext);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const category = documentCategories.find(
    (cat) => cat.id === parseInt(id, 10)
  );
  if (!category) return null;

  return (
    <motion.div
      className="relative min-h-screen flex flex-col items-center text-center px-6 pt-5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{
        backgroundImage: `url(${category.backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Ελαφρύ overlay */}
      <div className="absolute inset-0 bg-black/40 z-0"></div>

      {/* GRID */}
      <div
        className="
          grid gap-6
          grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
          justify-items-center
          mt-10 max-w-6xl w-full px-4 sm:px-6 relative z-10
        "
      >
        {category.links.map((link, i) => (
          <GlassCard
            key={i}
            icon={ExternalLink}
            title={language === "el" ? link.name : link.nameEn}
            desc={language === "el" ? link.description : link.descriptionEn}
            onClick={() => window.open(link.url, "_blank")}
          />
        ))}

        {category.subcategories?.map((sub, i) => (
          <GlassCard
            key={`sub-${i}`}
            title={language === "el" ? sub.name : sub.nameEn}
            desc={language === "el" ? sub.description : sub.descriptionEn}
            onClick={() => navigate(`/subcategory/${sub.id}`)}
          />
        ))}
      </div>

      {/* Διαφήμιση κατηγορίας */}
      <CategoryInlineAd />

      {/* Back button */}
      <button
        onClick={() => navigate("/")}
        className="mt-10 mb-20 glass-btn relative z-10"
      >
        {language === "el" ? "Πίσω στην Αρχική" : "Back to Home"}
      </button>
    </motion.div>
  );
};

export default CategoryPage;